import axios from "axios";
import routes from "../app/routes";

export const coachPoolTeamsActions = {
  loadTeams: (dispatch, coachPool) => {
    axios.get(routes.api.coach_pools.teams(coachPool.id)).then((resp) => {
      dispatch({
        type: "loadTeams",
        coachPool: coachPool,
        teams: resp.data.data,
      });
    });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
};
